import React, { FunctionComponent } from 'react';
import './index.scss';
import env from 'libs/env';
import urlParams from 'libs/query';
import { cx } from 'emotion';
import Cookie from 'js-cookie';
export interface OptionItem {
    id: number;
    name: string;
}

export interface Props {
    title: string;
    showBack: boolean;
    onBackButtonClicked?: () => void;
    options?: OptionItem[];
    onOptionItemSelected?: (item: OptionItem) => void;
    customClass?: string;
    showNotToutiaoPrd?: boolean;
}
const TitleBar: FunctionComponent<Props> = (props) => {
    const singleOption = props.options && props.options.length === 1 && props.options[0];

    // 头条产品线中，懂车帝无法隐藏端上的返回按钮，所以不隐藏端上的头部，也就不显示这个自定义头部了
    if (
        (!env.isInToutiaoProduct && !props.showNotToutiaoPrd) ||
        urlParams.hide_custom_title_bar ||
        env.isInMobile
    )
        return null;
    return (
        <div className={cx('title-bar', props.customClass)}>
            {props.showBack && (
                <div className="title-bar__back-button" onClick={props.onBackButtonClicked} />
            )}
            <div className="title-bar__title">{props.children || props.title}</div>
            {singleOption && (
                <div
                    className="title-bar__option"
                    onClick={() => {
                        if (props.onOptionItemSelected) props.onOptionItemSelected(singleOption);
                    }}
                >
                    {singleOption.name}
                </div>
            )}
        </div>
    );
};

export default TitleBar;
